class CNumbersSearcher extends Component {
    constructor(){
        super();

        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount() {
      this.setState({
        search_valid: true,
        search_value: (this.props.value ?? "")
    });
    }

    onInputChange(e){
        var self = this;
        var row = e.target.value;
        row = row.replace(",", ".");
        var value = Number(row);
        if (!Number.isFinite(value)){
            this.setState({search_valid: false, search_value: row});
        } else {
            this.setState({search_valid: true, search_value: value}, () => self.props.onValueChange(this.state.search_value, Number(e.target.dataset['filterindex'])))
        }
    }


    allowed_op(op){
        var ops = ["eq", "neq", "ge", "gt", "le", "lt", "in", "not_in"];

        if(this.props.column.editor_allow_null){
            ops.push("is_null");
            ops.push("is_not_null");
        }

        if(ops.includes(op))
            return op;
        return "eq";
    }

    render(){
      var self = this;
      return    <div>
                    <div class="select ml-2 mb-2">
                        <select value={self.props.column.name} data-filterindex={self.props.index} onChange={self.props.onColumnChange} title={_("Column to search")}>
                            {self.props.table.state.table_columns.filter(w =>  w.search_actor !== null).map(y => {
                                return <option value={y.name}>{y.label}</option>;
                            }) }
                        </select>
                    </div>
                    <div class="select ml-2 mb-2">
                        <select value={self.allowed_op(self.props.operator)} data-filterindex={self.props.index} onChange={self.props.onOperatorChange} title={_("Search kind")}>
                            <option value="eq">=</option>
                            <option value="neq">!=</option>
                            <option value="ge">&gt;=</option>
                            <option value="gt">&gt;</option>
                            <option value="le">&lt;=</option>
                            <option value="lt">&lt;</option>
                            <option value="in">IN</option>
                            <option value="not_in">NOT IN</option>
                            {self.props.column.editor_allow_null ? <option value="is_null">Is NULL</option> : ""}
                            {self.props.column.editor_allow_null ? <option value="is_not_null">Is not NULL</option> : ""}
                        </select>
                    </div>
                    <div class="ml-2 mb-2" style="display: inline-block;">
                        <input class={cls("input", self.state.search_valid ? "" : "is-danger")} type="text" value={self.state.search_value} data-filterindex={self.props.index} onChange={self.onInputChange}  title={_("Search value")}/>
                    </div>
                    <div class="ml-2 mb-2" style="display: inline-block;">
                        <button class="button is-danger is-soft" data-filterindex={self.props.index} onClick={self.props.onDeleteClick} title={_("Delete criteria")}><span class="material-symbols-outlined" translate={false}>delete</span></button>
                    </div>
                </div>;
    }
}

ctable_register_class("CNumbersSearcher", CNumbersSearcher);
